export const courseFeatures = [
  {
    value: "+66h",
    label: "Materiałów",
    description: "Kompleksowa wiedza w przystępnej formie"
  },
  {
    value: "14",
    label: "Kursów",
    description: "Każdy skupiony na innym aspekcie biznesu"
  },
  {
    value: "24/7",
    label: "Dostęp",
    description: "Ucz się w swoim tempie, kiedy chcesz"
  },
  {
    value: "∞",
    label: "Aktualizacje",
    description: "Regularne dodawanie nowych materiałów"
  }
] as const;